/**
 * Safely encode Unicode text to Base64
 * @param text Text to encode in Base64
 * @returns Base64 encoded string
 */
export function sfBase64Encode(text: string): string {
  return window.btoa(
    encodeURIComponent(text).replace(/%([0-9A-F]{2})/g, function (_match: string, hexValue: string): string {
      return String.fromCharCode(parseInt(hexValue, 16));
    })
  );
}

/**
 * Decode Base64 text with Unicode support
 * @param base64Text Text encoded in Base64
 * @returns Decoded original text
 */
export function sfBase64Decode(base64Text: string): string {
  const binaryString = window.atob(base64Text);
  const bytes = new Uint8Array(binaryString.length);

  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  return decodeURIComponent(
    Array.from(bytes)
      .map((byte) => '%' + byte.toString(16).padStart(2, '0'))
      .join('')
  );
}

/**
 * Convert data (object or string) to Base64
 * @param data Data to encode
 * @returns Base64 encoded string
 */
export function sfToBase64(data: Object | string): string {
  if (typeof data !== 'string') {
    data = JSON.stringify(data);
  }

  return sfBase64Encode(data as string);
}

export function sfDecodeJwt(idToken: string): Record<string, string | undefined> {
  const base64Url = idToken.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );
  return JSON.parse(jsonPayload);
}
